import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { withStyles } from '@mui/styles';

const styles = () => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  iframe: {
    border: 'none',
    width: '100%',
  },
});

const GoogleMap = ({ classes, className, query }) => {
  return (
    <div className={clsx(classes.root, className)}>
      <iframe
        className={classes.iframe}
        title="Google Map"
        height="420"
        allowfullscreen
        referrerPolicy="no-referrer-when-downgrade"
        src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&q=${query}`}
      />
    </div>
  );
};

GoogleMap.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  query: PropTypes.string,
};

GoogleMap.defaultProps = {
  classes: {},
  className: null,
  query: '',
};

export default withStyles(styles)(GoogleMap);
